import { Modal, Button } from "react-bootstrap";

const ConfirmationDialog = ({ show, onClose, onConfirm, confirmationMessage, outOfStockMessage }) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Action</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {confirmationMessage}
                {outOfStockMessage && (
                    <div style={{ marginTop: '10px', color: 'red' }}>
                        {outOfStockMessage}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationDialog;
